module.exports = __webpack_public_path__ + "40f76004198be492f41a9f6327c0c08e.png";


//////////////////
// WEBPACK FOOTER
// ./app/images/share-game.png
// module id = 494
// module chunks = 0